// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var BootstrapInputType;
(function (BootstrapInputType) {
    BootstrapInputType["Text"] = "text";
    BootstrapInputType["Email"] = "email";
    BootstrapInputType["Number"] = "number";
    BootstrapInputType["Password"] = "password";
    BootstrapInputType["Search"] = "search";
})(BootstrapInputType || (BootstrapInputType = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "left";
    IconPosition["Right"] = "right";
})(IconPosition || (IconPosition = {}));
